import { TipoEspacioI } from "interfaces/TipoEspacio";
import { ReactNode, useState } from "react";
import { Table } from "react-bootstrap";
import { TipoEspacioRow } from "./TipoEspacioRow";

interface Props {
  elementos: TipoEspacioI[];
  renderActions?: (elemento: TipoEspacioI) => ReactNode;
}

export const TipoEspacioTable = ({ elementos = [], renderActions }: Props) => {
  const [selectedNotificacionId, setSelectedNotificacionId] = useState<
    null | number | string
  >(null);

  const [showDetailModal, setShowDetailModal] = useState(false);

  const handleShowDetailModal = (id: number | string) => {
    setSelectedNotificacionId(id);
    setShowDetailModal(true);
  };

  const handleCloseModal = () => {
    setShowDetailModal(false);
  };

  return (
    <>
      <Table striped bordered className="table-container">
        <thead>
          <tr className="table-heading">
            <th>ID</th>
            <th>Nombre</th>
            <th>Con sub-tipo</th>
            {renderActions && (
              <th className="text-center" style={{ maxWidth: "50px" }}>
                Acciones
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          {elementos.length > 0 ? (
            elementos.map((ctEl) => (
              <TipoEspacioRow
                key={ctEl.id}
                elemento={ctEl}
                renderActions={renderActions}
              />
            ))
          ) : (
            <tr>
              <td
                colSpan={renderActions ? 6 : 5}
                className="text-center table-error-message"
              >
                <p>
                  <b>No hay tipo de espacio para visualizar.</b> Para poder
                  visualizar tipo de espacio debes <br /> seleccionar el botón
                  agregar «Nuevo Tipo de Espacio».
                </p>
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </>
  );
};
